var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToRelease(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4552 2.10944H14.1879V4.58451H19.2458C19.4146 4.58451 19.5505 4.72045 19.5505 4.8892V19.1068C19.5505 19.2756 19.4146 19.4115 19.2458 19.4115H14.1879V21.8913H20.4552C21.3224 21.8913 22.0256 21.1881 22.0256 20.3209V3.67979C22.0256 2.81258 21.3224 2.10944 20.4552 2.10944Z",
    fill: "#CAC4D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4769 0.0234382L3.17191 2.21725C2.48283 2.38132 2 2.9954 2 3.70323V20.3022C2 21.01 2.48751 21.6241 3.1766 21.7834L12.4816 23.9773C12.9409 24.0851 13.405 23.7991 13.5128 23.3397C13.5269 23.2741 13.5363 23.2085 13.5363 23.1429V0.857837C13.5363 0.384386 13.1519 0 12.6784 0C12.6081 0 12.5425 0.00937527 12.4769 0.0234382ZM10.7799 13.116C10.1612 13.116 9.66428 12.6144 9.66428 12.0003C9.66428 11.3816 10.1659 10.8847 10.7799 10.8847C11.3987 10.8847 11.8956 11.3863 11.8956 12.0003C11.8956 12.6191 11.394 13.116 10.7799 13.116Z",
    fill: "#CAC4D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToRelease);
export default __webpack_public_path__ + "static/media/to-release.f683184f.svg";
export { ForwardRef as ReactComponent };